<app-page-layout>
    <sh-breadcrumbs breadcrumbs>
        <sh-breadcrumb-item [label]="'common.general.home' | translate" href="/"></sh-breadcrumb-item>
        <sh-breadcrumb-item
            [label]="'breadcrumbs.initial-reagent-order' | translate"
            href="/request"
        ></sh-breadcrumb-item>
    </sh-breadcrumbs>

    <h1 class="text-xl sm:text-2xl font-bold text-shui-text-strong font-sh-bree-headline" title>
        {{ 'request.title' | translate }}
    </h1>

    <div actions>
        <sh-button
            [label]="'common.cancel' | translate"
            size="max-content"
            color="secondary"
            [routerLink]="'/'"
        ></sh-button>
    </div>

    <div class="flex-1 min-h-0 flex gap-8 relative">
        <app-stepper
            class="hidden md:block"
            [steps]="steps"
            [validSteps]="completedStepsArray()"
            [maxReachedStepIndex]="maxReachedStepIndex()"
        ></app-stepper>
        @if (initialLoading()) {
            <div class="flex-1 flex flex-col gap-6 p-4">
                <div class="h-6 w-48 bg-shui-base-3 rounded animate-pulse"></div>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    @for (i of [1, 2, 3, 4, 5, 6]; track i) {
                        <div class="flex flex-col gap-1">
                            <div class="h-3 w-24 bg-shui-base-3 rounded animate-pulse"></div>
                            <div class="h-5 w-full bg-shui-base-3 rounded animate-pulse mt-1"></div>
                        </div>
                    }
                </div>
                <div class="h-6 w-32 bg-shui-base-3 rounded animate-pulse mt-4"></div>
                <div class="h-[200px] w-full bg-shui-base-3 rounded animate-pulse"></div>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                    @for (i of [1, 2, 3, 4]; track i) {
                        <div class="flex flex-col gap-1">
                            <div class="h-3 w-24 bg-shui-base-3 rounded animate-pulse"></div>
                            <div class="h-5 w-full bg-shui-base-3 rounded animate-pulse mt-1"></div>
                        </div>
                    }
                </div>
            </div>
        }
        <div class="flex-1 max-h-full overflow-y-auto pr-2 -mr-2 md:pr-2 box-border" [class.hidden]="initialLoading()">
            @if (isStepRendered(0)) {
                <div id="form-step-0" class="min-h-full" [class.hidden]="isStepHidden(0)">
                    <app-deal-type (continue)="onContinue(0)"></app-deal-type>
                    <div class="w-full h-px bg-shui-base-4 my-8"></div>
                </div>
            }
            @if (isStepRendered(1)) {
                <div id="form-step-1" class="min-h-full" [class.hidden]="isStepHidden(1)">
                    @if (dealType() === DealType.INSTRUMENT_ONLY) {
                        <app-instrument-only
                            [showContinue]="!isStepCompleted(1) && !requestId"
                            (continue)="onContinue(1)"
                        ></app-instrument-only>
                    } @else if (dealType() === DealType.STANDARD_DEAL) {
                        <app-standard-deal
                            [showContinue]="!isStepCompleted(1) && !requestId"
                            (continue)="onContinue(1)"
                        ></app-standard-deal>
                    }
                    <div class="w-full h-px bg-shui-base-4 my-8"></div>
                </div>
            }
            @if (isStepRendered(2)) {
                <div id="form-step-2" class="min-h-full" [class.hidden]="isStepHidden(2)">
                    <app-order-details
                        [showContinue]="!isStepCompleted(2) && !requestId"
                        [materials]="materials()"
                        (continue)="onContinue(2)"
                        (pricingCleared)="onPricingCleared()"
                    ></app-order-details>
                    <div class="w-full h-px bg-shui-base-4 my-8"></div>
                </div>
            }
            @if (isStepRendered(3)) {
                <div id="form-step-3" class="min-h-full" [class.hidden]="isStepHidden(3)">
                    <app-contact-information
                        [showContinue]="!isStepCompleted(3) && !requestId"
                        [requestId]="requestId"
                        [loading]="isLoading()"
                        (continue)="onContinue(3)"
                        (saveChanged)="onSave()"
                        (submitChanged)="onSubmit()"
                        (deleteChanged)="onDelete()"
                    ></app-contact-information>
                    <div class="w-full h-px bg-shui-base-4 my-8"></div>
                </div>
            }
            @if (isStepRendered(4)) {
                <div id="form-step-4" class="min-h-full" [class.hidden]="isStepHidden(4)">
                    <app-overview
                        [dealType]="dealType()"
                        [customerInformation]="customerInformation()"
                        [productLine]="overviewProductLine()"
                        [soldToNumber]="soldToNumber()"
                        [shipToNumber]="shipToNumber()"
                        [materials]="materials()"
                        [contactData]="contactData()"
                        [orderDetailsData]="orderDetailsData()"
                        [serverFiles]="serverFiles()"
                        [requestId]="requestId"
                        [loading]="isLoading()"
                        (saveChanged)="onSave()"
                        (submitChanged)="onSubmit()"
                        (deleteChanged)="onDelete()"
                        (editStepChanged)="onEditFromOverview($event)"
                        (attachmentDownload)="onDownloadAttachment($event)"
                        (attachmentDelete)="onDeleteAttachment($event)"
                        (parallelReferralSubmitted)="onParallelReferralSubmit($event)"
                        (externalReferralSubmitted)="onExternalReferralSubmit($event)"
                    ></app-overview>
                </div>
            }
        </div></div
></app-page-layout>
